<div class="card m-b-10 base-shadow-list b-0">
  <div>
    <app-respondents-approval-search-page-header [hideApproveButton]="true" (searchRequestLoaded)="setSearchRequest($event)">
    </app-respondents-approval-search-page-header>
    <div class="m-l-20"  *ngIf="processAppraiseeDurationId">
      <span class="caption">{{ 'lang.approval.searchedCategory' | translate }}:</span>
      <span> {{ getSelectionColumnName() | async }}</span></div>
    <div class="ml-3 mr-3" *ngIf="processAppraiseeDurationId">
        <div class="row">
            <div class="add-search-respondent">
                <div class="float-left">
                    <input [(ngModel)]="term" type="text" name="name" placeholder="{{ 'lang.common.search' | translate }}" (ngModelChange)="emitSearchPattern($event)" />
                </div>
            </div>
            <div class="btn-cancel" (click)="return()">
                {{ 'lang.user.cancel'  | translate }}
            </div>
        </div>
      <div>
        <div *ngFor="let employee of employees" class="row p-t-10 p-b-10 br-respondent">
          <div class="col-4 pr-0">
            <app-user-avatar [employeeId]="employee.id"></app-user-avatar>
            <div class="float-left">
              <div class="font-weight-bold">
                {{ employee.displayName }}
              </div>
              <div>
                {{ employee.position.name }}
              </div>
            </div>
          </div>
          <div class="col-3 pr-0">
            <div>
              {{ employee.businessUnitDisplayName }}
            </div>
          </div>
          <div class="col-2 pr-0">
            <div class="float-right">
              {{ employee.grade.name }}
            </div>
          </div>
          <div class="col-2 pr-0">
            <div class="float-right">
              {{ getSelectionColumnName() | async }}
            </div>
          </div>
          <div class="col-1 text-right">
            <span (click)="addRespondent(employee)" class="add-btn test m-r-10">
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>